import { NumberInput, minValue } from "react-admin";
import { integerValidator } from "utils/validations";
import { CourseYearInput, DisciplineInput, GridItem, HoursInput } from "./Partials";

const CyclicSubDisciplineFields = ({ parentDisciplineId }) => (
  <>
    <DisciplineInput
      label="Под-цикъл"
      filter={{ parentId: parentDisciplineId }}
    />

    <HoursInput
      source="totalHours"
      label="Общо часове"
      md={3}
      isRequired
    />
    <HoursInput
      source="totalLectures"
      label="Общо лекции"
      md={3}
      isRequired
    />
    <HoursInput
      source="totalLabs"
      label="Общо упражнения"
      md={3}
      isRequired
    />
    <CourseYearInput
      source="schedule.year"
      md={3}
    />
    <GridItem md={6}>
      <NumberInput
        source="durationDays"
        label="Продължителност в учебни дни"
        fullWidth
        min={0}
        step={1}
        validate={[minValue(0, "Минималната стойност е 0."), integerValidator]}
        onWheel={e => e.target.blur()}
      />
    </GridItem>
    <HoursInput
      source="extracurricularActivities"
      label="Извънаудиторна заетост"
      md={6}
    />
  </>
);

export default CyclicSubDisciplineFields;
